import { gql } from "@apollo/client";

/**
 * Fetches all active permit authorities for permit application flow.
 */
export const GET_PERMIT_AUTHORITIES = gql`
  query GetPermitAuthorities {
    authorities: permit_active_authority(order_by: [{ name: asc }]) {
      clientId: client_id
      payeeAccountId: payee_account_id
      name
    }
  }
`;

export interface PermitAuthorityRaw {
  clientId: string;
  payeeAccountId: string;
  name: string;
}

export interface GetPermitAuthoritiesData {
  authorities: PermitAuthorityRaw[];
}

export default GET_PERMIT_AUTHORITIES;
